import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDJAthWBR1bgPFsYdLEPiyQcqOADtOp4yI",
    authDomain: "cra-brainy.firebaseapp.com",
    projectId: "cra-brainy",
    storageBucket: "cra-brainy.appspot.com",
    messagingSenderId: "323971939203",
    appId: "1:323971939203:web:00a125c2605fb8058fd4b6",
    measurementId: "G-9M4K3CKFEN"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const firestore = getFirestore(app);

export default firestore;